import React from 'react';
import {
  BottomCard,
  BottomMember,
  BottomFile,
  BottomInfo,
  Box,
  Cards,
  Circle,
  Desc,
  Detail,
  FileCards,
  Files,
  First,
  FirstCard,
  FirstFile,
  FirstInfo,
  FirstMember,
  Forth,
  Header,
  Heading,
  Icon,
  Invoice,
  LeftDiv,
  LeftInfo,
  LeftSide,
  LeftTop,
  Link,
  MainDiv,
  Name,
  Profile,
  Project,
  Right,
  RightDiv,
  RightInfo,
  RightTop,
  Second,
  Table,
  Third,
  Title,
  TopCard,
  TopFile,
  TopInfo,
  TopMember,
  Topright
} from './styles';
import { useSelector } from 'react-redux';
import customProfileDark from '../../../assets/images/customerprofiledark.svg';
import customProfileLight from '../../../assets/images/customeprofilelight.svg';
import SVGIcon from '../../../assets/images/svg/SVGIcon';
import { RootReducerInterface } from '../../../interfaces/RootReducerInterface';

export default function CustomerDetailLoading() {
  //use selector state variables
  const settingsSelector = useSelector((state: RootReducerInterface) => state.settings);
  const { themeMode } = settingsSelector;
  return (
    <div style={{ width: '100%' }}>
      <MainDiv>
        <LeftDiv>
          <Header>
            <Profile>
              {themeMode?.theme === 'dark' ? (
                <img src={customProfileDark} width={58} height={58} alt='logo' />
              ) : (
                <img src={customProfileLight} width={58} height={58} alt='logo' />
              )}
              <Name>
                <First className='loading-animation' />
                <Desc className='loading-animation' />
              </Name>
            </Profile>
            <Icon>
              <SVGIcon name='large-more-icon' width='24' height='24' viewBox='0 0 24 24' className='large-more-icon' />
            </Icon>
          </Header>
          <Project>
            <Title>Projects</Title>
            <Cards>
              <FirstCard>
                <TopCard>
                  <Detail>
                    <LeftSide>
                      <First className='loading-animation' />
                      <First className='loading-animation bottom' />
                    </LeftSide>
                    <Right className='loading-animation'></Right>
                  </Detail>
                  <First className='loading-animation last-bottom' />
                </TopCard>
                <BottomCard>
                  <Circle className='loading-animation' />
                  <Circle className='loading-animation' />
                  <Circle className='loading-animation' />
                  <Circle className='loading-animation' />
                  <Circle className='loading-animation' />
                </BottomCard>
              </FirstCard>
              <FirstCard>
                <TopCard>
                  <Detail>
                    <LeftSide>
                      <First className='loading-animation' />
                      <First className='loading-animation bottom' />
                    </LeftSide>
                    <Right className='loading-animation'></Right>
                  </Detail>
                  <First className='loading-animation last-bottom' />
                </TopCard>
                <BottomCard>
                  <Circle className='loading-animation' />
                  <Circle className='loading-animation' />
                  <Circle className='loading-animation' />
                  <Circle className='loading-animation' />
                  <Circle className='loading-animation' />
                </BottomCard>
              </FirstCard>
              <FirstCard>
                <TopCard>
                  <Detail>
                    <LeftSide>
                      <First className='loading-animation' />
                      <First className='loading-animation bottom' />
                    </LeftSide>
                    <Right className='loading-animation'></Right>
                  </Detail>
                  <First className='loading-animation last-bottom' />
                </TopCard>
                <BottomCard>
                  <Circle className='loading-animation' />
                  <Circle className='loading-animation' />
                  <Circle className='loading-animation' />
                  <Circle className='loading-animation' />
                  <Circle className='loading-animation' />
                </BottomCard>
              </FirstCard>
            </Cards>
          </Project>
          <Files>
            <Heading>
              <Title>Document & Files</Title>
              <Link>+ Add</Link>
            </Heading>
            <FileCards>
              <FirstFile>
                <TopFile>
                  <SVGIcon name='file-loading-icon' width='60' height='60' viewBox='0 0 60 60' className='fill-color' />
                </TopFile>
                <BottomFile>
                  <First className='top loading-animation' />
                  <First className='bottom loading-animation' />
                </BottomFile>
              </FirstFile>
              <FirstFile>
                <TopFile>
                  <SVGIcon
                    name='document-loading-icon'
                    width='60'
                    height='60'
                    viewBox='0 0 60 60'
                    className='fill-color'
                  />
                </TopFile>
                <BottomFile>
                  <First className='top loading-animation' />
                  <First className='bottom loading-animation' />
                </BottomFile>
              </FirstFile>
              <FirstFile>
                <TopFile>
                  <SVGIcon
                    name='image-loading-icon'
                    width='60'
                    height='60'
                    viewBox='0 0 60 60'
                    className='fill-color'
                  />
                </TopFile>
                <BottomFile>
                  <First className='top loading-animation' />
                  <First className='bottom loading-animation' />
                </BottomFile>
              </FirstFile>
              <FirstFile>
                <TopFile>
                  <SVGIcon name='pdf-loading-icon' width='60' height='60' viewBox='0 0 60 60' className='fill-color' />
                </TopFile>
                <BottomFile>
                  <First className='top loading-animation' />
                  <First className='bottom loading-animation' />
                </BottomFile>
              </FirstFile>
            </FileCards>
          </Files>
          <Invoice>
            <Heading>
              <Title>Invoices</Title>
              <Link>See All</Link>
            </Heading>
            <Table>
              <thead>
                <tr className='row'>
                  <th>
                    <p>Invoice no</p>
                    <SVGIcon name='line' width='1' height='21' viewBox='0 0 1 21' className='lineIcon' />
                  </th>
                  <th>
                    <p>Invoice Date</p>
                    <SVGIcon name='line' width='1' height='21' viewBox='0 0 1 21' className='lineIcon' />
                  </th>
                  <th>
                    <p>Amount</p>
                    <SVGIcon name='line' width='1' height='21' viewBox='0 0 1 21' className='lineIcon' />
                  </th>
                  <th>
                    <p>Status</p>
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr className='first-row'>
                  <td>
                    <First className='first loading-animation'></First>
                  </td>
                  <td>
                    <Second>
                      <First className='top loading-animation' />
                      <First className='bottom loading-animation' />
                    </Second>
                  </td>
                  <td>
                    <Third>
                      <First className='top loading-animation' />
                      <First className='bottom loading-animation' />
                    </Third>
                  </td>
                  <td>
                    <Forth>
                      <First className='top loading-animation' />
                    </Forth>
                  </td>
                  <td>
                    <Icon>
                      <SVGIcon name='more-icon' width='18' height='18' viewBox='0 0 18 18' className='more-icon' />
                    </Icon>
                  </td>
                </tr>
                <tr className='first-row'>
                  <td>
                    <First className='first loading-animation'></First>
                  </td>
                  <td>
                    <Second>
                      <First className='top loading-animation' />
                      <First className='bottom loading-animation' />
                    </Second>
                  </td>
                  <td>
                    <Third>
                      <First className='top loading-animation' />
                      <First className='bottom loading-animation' />
                    </Third>
                  </td>
                  <td>
                    <Forth>
                      <First className='top loading-animation' />
                    </Forth>
                  </td>
                  <td>
                    <Icon>
                      <SVGIcon name='more-icon' width='18' height='18' viewBox='0 0 18 18' className='more-icon' />
                    </Icon>
                  </td>
                </tr>
                <tr className='first-row'>
                  <td>
                    <First className='first loading-animation'></First>
                  </td>
                  <td>
                    <Second>
                      <First className='top loading-animation' />
                      <First className='bottom loading-animation' />
                    </Second>
                  </td>
                  <td>
                    <Third>
                      <First className='top loading-animation' />
                      <First className='bottom loading-animation' />
                    </Third>
                  </td>
                  <td>
                    <Forth>
                      <First className='top loading-animation' />
                    </Forth>
                  </td>
                  <td>
                    <Icon>
                      <SVGIcon name='more-icon' width='18' height='18' viewBox='0 0 18 18' className='more-icon' />
                    </Icon>
                  </td>
                </tr>
                <tr className='first-row'>
                  <td>
                    <First className='first loading-animation'></First>
                  </td>
                  <td>
                    <Second>
                      <First className='top loading-animation' />
                      <First className='bottom loading-animation' />
                    </Second>
                  </td>
                  <td>
                    <Third>
                      <First className='top loading-animation' />
                      <First className='bottom loading-animation' />
                    </Third>
                  </td>
                  <td>
                    <Forth>
                      <First className='top loading-animation' />
                    </Forth>
                  </td>
                  <td>
                    <Icon>
                      <SVGIcon name='more-icon' width='18' height='18' viewBox='0 0 18 18' className='more-icon' />
                    </Icon>
                  </td>
                </tr>
                <tr className='first-row'>
                  <td>
                    <First className='first loading-animation'></First>
                  </td>
                  <td>
                    <Second>
                      <First className='top loading-animation' />
                      <First className='bottom loading-animation' />
                    </Second>
                  </td>
                  <td>
                    <Third>
                      <First className='top loading-animation' />
                      <First className='bottom loading-animation' />
                    </Third>
                  </td>
                  <td>
                    <Forth>
                      <First className='top loading-animation' />
                    </Forth>
                  </td>
                  <td>
                    <Icon>
                      <SVGIcon name='more-icon' width='18' height='18' viewBox='0 0 18 18' className='more-icon' />
                    </Icon>
                  </td>
                </tr>
                <tr className='first-row'>
                  <td>
                    <First className='first loading-animation'></First>
                  </td>
                  <td>
                    <Second>
                      <First className='top loading-animation' />
                      <First className='bottom loading-animation' />
                    </Second>
                  </td>
                  <td>
                    <Third>
                      <First className='top loading-animation' />
                      <First className='bottom loading-animation' />
                    </Third>
                  </td>
                  <td>
                    <Forth>
                      <First className='top loading-animation' />
                    </Forth>
                  </td>
                  <td>
                    <Icon>
                      <SVGIcon name='more-icon' width='18' height='18' viewBox='0 0 18 18' className='more-icon' />
                    </Icon>
                  </td>
                </tr>
                <tr className='first-row'>
                  <td>
                    <First className='first loading-animation'></First>
                  </td>
                  <td>
                    <Second>
                      <First className='top loading-animation' />
                      <First className='bottom loading-animation' />
                    </Second>
                  </td>
                  <td>
                    <Third>
                      <First className='top loading-animation' />
                      <First className='bottom loading-animation' />
                    </Third>
                  </td>
                  <td>
                    <Forth>
                      <First className='top loading-animation' />
                    </Forth>
                  </td>
                  <td>
                    <Icon>
                      <SVGIcon name='more-icon' width='18' height='18' viewBox='0 0 18 18' className='more-icon' />
                    </Icon>
                  </td>
                </tr>
                <tr className='first-row'>
                  <td>
                    <First className='first loading-animation'></First>
                  </td>
                  <td>
                    <Second>
                      <First className='top loading-animation' />
                      <First className='bottom loading-animation' />
                    </Second>
                  </td>
                  <td>
                    <Third>
                      <First className='top loading-animation' />
                      <First className='bottom loading-animation' />
                    </Third>
                  </td>
                  <td>
                    <Forth>
                      <First className='top loading-animation' />
                    </Forth>
                  </td>
                  <td>
                    <Icon>
                      <SVGIcon name='more-icon' width='18' height='18' viewBox='0 0 18 18' className='more-icon' />
                    </Icon>
                  </td>
                </tr>
              </tbody>
            </Table>
          </Invoice>
        </LeftDiv>
        <RightDiv>
          <Topright>
            <Heading>
              <Title>Member</Title>
              <Link>+ Add</Link>
            </Heading>
            <Box>
              <FirstMember>
                <TopMember>
                  <LeftTop className='loading-animation'></LeftTop>
                  <RightTop>
                    <LeftTop className='right loading-animation'></LeftTop>
                    <Icon>
                      <SVGIcon name='more-icon' width='18' height='18' viewBox='0 0 18 18' className='more-icon' />
                    </Icon>
                  </RightTop>
                </TopMember>
                <BottomMember className='loading-animation'></BottomMember>
              </FirstMember>
              <FirstMember>
                <TopMember>
                  <LeftTop className='loading-animation'></LeftTop>
                  <RightTop>
                    <Icon>
                      <SVGIcon name='more-icon' width='18' height='18' viewBox='0 0 18 18' className='more-icon' />
                    </Icon>
                  </RightTop>
                </TopMember>
                <BottomMember className='loading-animation'></BottomMember>
              </FirstMember>
              <FirstMember>
                <TopMember>
                  <LeftTop className='loading-animation'></LeftTop>
                  <RightTop>
                    <Icon>
                      <SVGIcon name='more-icon' width='18' height='18' viewBox='0 0 18 18' className='more-icon' />
                    </Icon>
                  </RightTop>
                </TopMember>
                <BottomMember className='loading-animation'></BottomMember>
              </FirstMember>
            </Box>
          </Topright>
          <Topright>
            <Title>Additional Info</Title>
            <Box className='secondBox'>
              <FirstInfo>
                <TopInfo>
                  <LeftInfo className='loading-animation' />
                  <RightInfo className='loading-animation' />
                </TopInfo>
                <BottomInfo className='loading-animation' />
              </FirstInfo>
              <FirstInfo>
                <TopInfo>
                  <LeftInfo className='loading-animation' />
                </TopInfo>
                <BottomInfo className='loading-animation' />
              </FirstInfo>
              <FirstInfo>
                <TopInfo>
                  <LeftInfo className='loading-animation' />
                </TopInfo>
                <BottomInfo className='loading-animation' />
              </FirstInfo>
              <FirstInfo>
                <TopInfo>
                  <LeftInfo className='loading-animation' />
                </TopInfo>
                <BottomInfo className='loading-animation' />
              </FirstInfo>
            </Box>
          </Topright>
        </RightDiv>
      </MainDiv>
    </div>
  );
}
